"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fabric_1 = require("@aperza/fabric");
var ui_1 = require("@aperza/ui");
var AcPdf_1 = require("../pdf/AcPdf");
var CreateStamp_1 = require("./stamps/CreateStamp");
exports.rotateObjects = function (rotate, originalWidth, originalHeight, fabricCanvasInstance, renderAll) {
    if (renderAll === void 0) { renderAll = true; }
    var _a, _b, _c;
    // this fixes a bug in fabric where the objects in a group are not updated
    (_c = (_b = (_a = fabricCanvasInstance.getActiveObjects()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.group) === null || _c === void 0 ? void 0 : _c.destroy();
    var rotateObjectsInner = function (rotationPoint, modifiedRotate) {
        var radians = fabric_1.fabric.util.degreesToRadians(modifiedRotate);
        fabricCanvasInstance.getObjects().forEach(function (obj) {
            var objectOrigin = new fabric_1.fabric.Point(obj.left, obj.top);
            var new_loc = fabric_1.fabric.util.rotatePoint(objectOrigin, rotationPoint, radians);
            obj.top = new_loc.y;
            obj.left = new_loc.x;
            obj.angle += modifiedRotate;
            obj.setCoords();
        });
    };
    switch (rotate) {
        case 90:
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), 90);
            break;
        case 180:
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), 180);
            break;
        case 270:
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), 180);
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), 90);
            break;
        case -90:
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), -90);
            break;
        case -180:
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), -180);
            break;
        case -270:
            rotateObjectsInner(new fabric_1.fabric.Point(originalHeight / 2, originalHeight / 2), -90);
            rotateObjectsInner(new fabric_1.fabric.Point(originalWidth / 2, originalHeight / 2), -180);
            break;
        default:
            break;
    }
    if (renderAll) {
        fabricCanvasInstance.renderAll();
    }
};
exports.scaleObjects = function (xScale, yScale, fabricCanvasInstance, renderAll) {
    if (renderAll === void 0) { renderAll = true; }
    fabricCanvasInstance.getObjects().forEach(function (obj) {
        obj.scaleX = xScale * obj.scaleX;
        obj.scaleY = yScale * obj.scaleY;
        obj.top = yScale * obj.top;
        obj.left = xScale * obj.left;
        obj.setCoords();
    });
    if (renderAll) {
        fabricCanvasInstance.renderAll();
    }
};
exports.AcPdfEditorCanvas = function (_a) {
    var fabricDataMapJSON = _a.fabricDataMapJSON, originalWidth = _a.originalWidth, originalHeight = _a.originalHeight, rotatedWidth = _a.rotatedWidth, rotatedHeight = _a.rotatedHeight, _b = _a.pageNumber, pageNumber = _b === void 0 ? 0 : _b, _c = _a.rotate, rotate = _c === void 0 ? 0 : _c, updateRotationArray = _a.updateRotationArray;
    var canvasDivElementRef = react_1.useRef(null);
    var canvasElementRef = react_1.useRef(null);
    var _d = react_1.useState(), fabricCanvas = _d[0], setFabricCanvas = _d[1];
    var _e = react_1.useState(0), newStampOffsetCounter = _e[0], setNewStampOffsetCounter = _e[1];
    var canvasMethodsRef = react_1.useContext(AcPdf_1.CanvasContext);
    var _f = react_1.useState({
        fabricData: [],
        rotationArray: [],
        existingPages: [],
    }), fabricDataMap = _f[0], setFabricDataMapState = _f[1];
    var _g = react_1.useState(null), copiedObjects = _g[0], setCopiedObjects = _g[1];
    var prevOriginalWidth = ui_1.usePrevious(originalWidth);
    var prevOriginalHeight = ui_1.usePrevious(originalHeight);
    var prevPageNumber = ui_1.usePrevious(pageNumber);
    var prevRotate = ui_1.usePrevious(rotate);
    var hideCanvas = function () {
        if (canvasDivElementRef && canvasDivElementRef.current) {
            canvasDivElementRef.current.style.display = 'none';
        }
    };
    var showCanvas = function () {
        if (canvasDivElementRef && canvasDivElementRef.current) {
            canvasDivElementRef.current.style.display = 'block';
        }
    };
    var deleteObject = function (event) {
        var _a, _b;
        if (event.keyCode === 46 || event.keyCode === 8) {
            // listens for delete or backspace keypress
            event.preventDefault();
            var activeObjects = fabricCanvas.getActiveObjects();
            (_b = (_a = activeObjects === null || activeObjects === void 0 ? void 0 : activeObjects[0]) === null || _a === void 0 ? void 0 : _a.group) === null || _b === void 0 ? void 0 : _b.destroy(); // this fixes a bug in fabric where the objects in a group are not updated
            activeObjects.forEach(function (object) { return fabricCanvas.remove(object); });
        }
    };
    var copyPaste = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var activeObjects, clonedObjects;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (event.key === 'c' && (event.ctrlKey || event.metaKey)) {
                        event.preventDefault();
                        activeObjects = fabricCanvas.getActiveObjects();
                        setCopiedObjects(activeObjects);
                    }
                    if (!(event.key === 'v' && (event.ctrlKey || event.metaKey))) return [3 /*break*/, 2];
                    event.preventDefault();
                    if (!(copiedObjects === null || copiedObjects === void 0 ? void 0 : copiedObjects.length)) return [3 /*break*/, 2];
                    (_a = copiedObjects[0].group) === null || _a === void 0 ? void 0 : _a.destroy(); // this fixes a bug in fabric where the objects in a group are not updated
                    return [4 /*yield*/, Promise.all(copiedObjects.map(function (object) {
                            return CreateStamp_1.cloneFabricObject(object);
                        }))];
                case 1:
                    clonedObjects = _b.sent();
                    clonedObjects.forEach(function (clonedObject, index) {
                        canvasMethodsRef.current.addStamp(clonedObject, copiedObjects[index].left + 20, copiedObjects[index].top + 20, copiedObjects[index].scaleX, copiedObjects[index].scaleY);
                    });
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var keyDownHandler = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if (!fabricCanvas)
                return [2 /*return*/];
            if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.nodeName) === 'INPUT' ||
                ((_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.nodeName) === 'TEXTAREA') {
                // don't do anything if editing text
                return [2 /*return*/];
            }
            deleteObject(event);
            copyPaste(event);
            return [2 /*return*/];
        });
    }); };
    var deleteEmptyText = function (options) {
        if (options.deselected) {
            var previousObject = options.deselected[0];
            if (previousObject.hasOwnProperty('text') && previousObject.text.trim().length === 0) {
                previousObject.canvas.remove(previousObject);
            }
        }
    };
    var addShadow = function (options) {
        var _a;
        (_a = options.selected) === null || _a === void 0 ? void 0 : _a.forEach(function (object) {
            object.shadow = new fabric_1.fabric.Shadow({
                color: 'rgba(0,0,0,0.3)',
                offsetX: 2,
                offsetY: 2,
                blur: 4,
            });
        });
    };
    var removeShadow = function (options) {
        var _a;
        (_a = options.deselected) === null || _a === void 0 ? void 0 : _a.forEach(function (object) {
            object.shadow = undefined;
        });
    };
    var keepObjectVisible = function (activeObject) {
        var coords = activeObject.calcCoords(true);
        var leftMost = Math.min(coords.bl.x, coords.br.x, coords.tl.x, coords.tr.x);
        var rightMost = Math.max(coords.bl.x, coords.br.x, coords.tl.x, coords.tr.x);
        var topMost = Math.min(coords.bl.y, coords.br.y, coords.tl.y, coords.tr.y);
        var bottomMost = Math.max(coords.bl.y, coords.br.y, coords.tl.y, coords.tr.y);
        var _a = activeObject.canvas, width = _a.width, height = _a.height;
        var modified = false;
        if (leftMost < 0) {
            activeObject.set('left', coords.tl.x + -leftMost);
            modified = true;
        }
        if (rightMost > width) {
            activeObject.set('left', coords.tl.x - (rightMost - width));
            modified = true;
        }
        if (topMost < 0) {
            activeObject.set('top', coords.tl.y + -topMost);
            modified = true;
        }
        if (bottomMost > height) {
            activeObject.set('top', coords.tl.y - (bottomMost - height));
            modified = true;
        }
        return modified;
    };
    var onObjectMoving = function (props) {
        setNewStampOffsetCounter(0);
        keepObjectVisible(props.target);
    };
    var exportCurrentPageToJson = function (_rotate, _originalWidth, _originalHeight) {
        if (_rotate === void 0) { _rotate = rotate; }
        if (_originalWidth === void 0) { _originalWidth = originalWidth; }
        if (_originalHeight === void 0) { _originalHeight = originalHeight; }
        if (fabricCanvas) {
            exports.rotateObjects(-_rotate, _originalWidth, _originalHeight, fabricCanvas, false); // we want to save objects in their unrotated state
            var json = fabricCanvas.toJSON(Object.keys(CreateStamp_1.styleOptions));
            json.dimensions = { width: _originalWidth, height: _originalHeight };
            json.rotate = _rotate;
            // Rotate back the objects
            exports.rotateObjects(_rotate, _originalWidth, _originalHeight, fabricCanvas, false);
            return json;
        }
        return undefined;
    };
    var saveFabricCanvas = function (_pageNumber, _rotate, _originalWidth, _originalHeight) {
        var json = exportCurrentPageToJson(_rotate, _originalWidth, _originalHeight);
        fabricDataMap.fabricData[_pageNumber - 1] = json;
    };
    /**
     * Immediately hide canvas if the pageNumber has changed.
     * Canvas is showns after render event => after:render
     */
    if (fabricCanvas && prevPageNumber && prevPageNumber !== pageNumber) {
        hideCanvas();
    }
    react_1.useEffect(function () {
        if (fabricCanvas) {
            fabricCanvas.setWidth(rotatedWidth);
            fabricCanvas.setHeight(rotatedHeight);
            if (prevPageNumber !== undefined && pageNumber) {
                if (prevPageNumber !== pageNumber) {
                    saveFabricCanvas(prevPageNumber, prevRotate, prevOriginalWidth || originalWidth, prevOriginalHeight || originalHeight);
                    fabricCanvas.clear();
                    if (fabricDataMap.fabricData[pageNumber - 1]) {
                        (function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, new Promise(function (resolve) {
                                            // original, unrotated positions
                                            var fabricData = fabricDataMap.fabricData[pageNumber - 1];
                                            fabricCanvas.loadFromJSON(fabricData, function () {
                                                var xScale = originalWidth / (fabricData.dimensions.width || originalWidth);
                                                var yScale = originalHeight / (fabricData.dimensions.height || originalHeight);
                                                exports.scaleObjects(xScale, yScale, fabricCanvas, false);
                                                exports.rotateObjects(rotate, originalWidth, originalHeight, fabricCanvas, false);
                                                resolve();
                                            });
                                        })];
                                    case 1:
                                        _a.sent();
                                        // remove shadows, kind of a work around to a fabric bug
                                        fabricCanvas.getObjects().forEach(function (object) {
                                            object.shadow = undefined;
                                        });
                                        fabricCanvas.renderAll();
                                        return [2 /*return*/];
                                }
                            });
                        }); })();
                    }
                    else {
                        fabricCanvas.renderAll();
                    }
                }
                else {
                    // rotate change only. pageNumber remains the same
                    if (prevRotate !== rotate) {
                        exports.rotateObjects(-(prevRotate || 0), prevOriginalWidth || originalWidth, prevOriginalHeight || originalHeight, fabricCanvas, false);
                    }
                    var xScale = originalWidth / (prevOriginalWidth || originalWidth);
                    var yScale = originalHeight / (prevOriginalHeight || originalHeight);
                    exports.scaleObjects(xScale, yScale, fabricCanvas, false);
                    if (prevRotate !== rotate) {
                        exports.rotateObjects(rotate, originalWidth, originalHeight, fabricCanvas, true);
                    }
                }
            }
        }
    }, [pageNumber, rotate, rotatedWidth, rotatedHeight]);
    react_1.useEffect(function () {
        return function () {
            // AcPdfEditorCanvas Clean up
            document.removeEventListener('keydown', deleteObject);
            fabricCanvas === null || fabricCanvas === void 0 ? void 0 : fabricCanvas.dispose();
        };
    }, []);
    react_1.useEffect(function () {
        document.addEventListener('keydown', keyDownHandler);
        return function () {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [fabricCanvas, copiedObjects]); // copyPaste relies on copiedObjects, so it must be watched
    react_1.useEffect(function () {
        if (!fabricCanvas) {
            var _fabricCanvas = new fabric_1.fabric.Canvas(canvasElementRef.current, {
                width: rotatedWidth,
                height: rotatedHeight,
            });
            _fabricCanvas.on('object:moving', onObjectMoving);
            _fabricCanvas.on('selection:updated', deleteEmptyText);
            _fabricCanvas.on('selection:cleared', deleteEmptyText);
            _fabricCanvas.on('after:render', showCanvas);
            _fabricCanvas.on('selection:created', addShadow);
            _fabricCanvas.on('selection:updated', addShadow);
            _fabricCanvas.on('selection:cleared', removeShadow);
            _fabricCanvas.on('selection:updated', removeShadow);
            setFabricCanvas(_fabricCanvas);
            // initialize with draft data, if available
            if (fabricDataMapJSON) {
                try {
                    var fabricDataMapParsed = JSON.parse(fabricDataMapJSON);
                    setFabricDataMapState(fabricDataMapParsed);
                    updateRotationArray(fabricDataMapParsed.rotationArray);
                }
                catch (e) {
                    console.error('Invalid pdf editor JSON');
                }
            }
        }
    }, [canvasElementRef.current]);
    /**
     * Without delay the renderAll may not be executed.
     * https://stackoverflow.com/questions/33529629/fabric-js-image-is-not-visible-on-canvas-until-selected
     * Otherwise, out of canvas stamp will not show after it has been processed by keepObjectVisible.
     */
    var updateCanvas = function () {
        setTimeout(function () {
            fabricCanvas.renderAll();
        }, 25);
    };
    react_1.useImperativeHandle(canvasMethodsRef, function () { return ({
        resetNewStampOffsetCounter: function () {
            setNewStampOffsetCounter(0);
        },
        setRotationArray: function (rotationArray) {
            fabricDataMap.rotationArray = rotationArray;
        },
        getRotationArray: function () {
            return fabricDataMap.rotationArray;
        },
        setExistingPages: function (existingPages) {
            fabricDataMap.existingPages = existingPages;
        },
        getExistingPages: function () {
            return fabricDataMap.existingPages;
        },
        exportToJpg: function () {
            return fabricCanvas.toDataURL({
                format: 'jpeg',
                quality: 1.0,
                multiplier: 1.5,
                enableRetinaScaling: true,
            });
        },
        exportToPng: function () {
            return fabricCanvas.toDataURL({
                format: 'png',
                multiplier: 1.5,
                enableRetinaScaling: true,
            });
        },
        // exportCurrentPageToJson(_rotate: number = rotate) {
        //   rotateObjects(-_rotate, originalWidth, originalHeight, fabricCanvas, false); // we want to save objects in their unrotated state
        //   const json = fabricCanvas.toJSON();
        //   rotateObjects(_rotate, originalWidth, originalHeight, fabricCanvas, false); // reset rotation to how it was
        //   json.dimensions = { width: originalWidth, height: originalHeight };
        //   json.rotate = _rotate;
        //   return json;
        // },
        getFabricDataMap: function (_pageNumber, _rotate) {
            if (_pageNumber === void 0) { _pageNumber = pageNumber; }
            if (_rotate === void 0) { _rotate = rotate; }
            // save currently editing page
            var json = exportCurrentPageToJson(_rotate);
            fabricDataMap.fabricData[_pageNumber - 1] = json;
            return fabricDataMap;
        },
        setFabricDataMap: function (map) {
            setFabricDataMapState(map);
        },
        addStamp: function (syncStamp, left, top, scaleX, scaleY, stampMetaData) { return __awaiter(void 0, void 0, void 0, function () {
            var newStampOffset, scale, arrayOfWidths, widestLineWidth, targetWidth, fractionOfPage, regex, regexResult, imageName, stampLeft, stampTop, modified;
            var _a;
            return __generator(this, function (_b) {
                newStampOffset = 20;
                if ((stampMetaData === null || stampMetaData === void 0 ? void 0 : stampMetaData.type) === 'setPhrase') {
                    arrayOfWidths = syncStamp.textLines.map(function (_, index) { return syncStamp.measureLine(index).width + 1; });
                    widestLineWidth = Math.max.apply(Math, arrayOfWidths);
                    syncStamp.width = widestLineWidth;
                    targetWidth = Math.max(syncStamp.width, 100);
                    scale = targetWidth / syncStamp.width;
                }
                else if ((stampMetaData === null || stampMetaData === void 0 ? void 0 : stampMetaData.type) === 'textbox') {
                    // free textbox stamp
                    // The width of an empty textbox is NaN
                    syncStamp.set({ width: Number.isNaN(syncStamp.width) ? 1 : syncStamp.width });
                    scale = 1;
                }
                else {
                    fractionOfPage = 0.1;
                    regex = /(\/)(\w*)(\.svg$)/;
                    regexResult = regex.exec((_a = stampMetaData === null || stampMetaData === void 0 ? void 0 : stampMetaData.imageUrl) !== null && _a !== void 0 ? _a : '');
                    imageName = regexResult === null || regexResult === void 0 ? void 0 : regexResult[2];
                    switch (imageName) {
                        case 'common_double_line_horizontal':
                            fractionOfPage = 0.05;
                            break;
                        case 'common_double_line_diagonal':
                            fractionOfPage = 0.05;
                            break;
                        case 'common_circle':
                            fractionOfPage = 0.05;
                            break;
                        case 'common_arrow':
                            fractionOfPage = 0.05;
                            break;
                        case 'common_onchu':
                            fractionOfPage = 0.075;
                            break;
                        case 'common_sama':
                            fractionOfPage = 0.038;
                            break;
                        default:
                            fractionOfPage = 0.1;
                            break;
                    }
                    scale =
                        (Math.min(rotatedWidth, rotatedHeight) / Math.max(syncStamp.width, syncStamp.height)) *
                            fractionOfPage;
                }
                syncStamp.scaleX = scaleX !== null && scaleX !== void 0 ? scaleX : scale;
                syncStamp.scaleY = scaleY !== null && scaleY !== void 0 ? scaleY : scale;
                stampLeft = rotatedWidth / 2 - syncStamp.getScaledWidth() / 2 + newStampOffsetCounter * newStampOffset;
                stampTop = rotatedHeight / 2 -
                    syncStamp.getScaledHeight() / 2 +
                    newStampOffsetCounter * newStampOffset;
                syncStamp.set({ left: left !== null && left !== void 0 ? left : stampLeft, top: top !== null && top !== void 0 ? top : stampTop });
                fabricCanvas.add(syncStamp);
                // If textbox, focus on textbox to activate curson
                if ((stampMetaData === null || stampMetaData === void 0 ? void 0 : stampMetaData.type) === 'textbox') {
                    syncStamp.enterEditing();
                    syncStamp.hiddenTextarea.focus();
                }
                modified = keepObjectVisible(syncStamp);
                fabricCanvas.setActiveObject(syncStamp);
                if (modified) {
                    updateCanvas();
                }
                scaleX !== null && scaleX !== void 0 ? scaleX : setNewStampOffsetCounter(newStampOffsetCounter + 1);
                return [2 /*return*/];
            });
        }); },
    }); });
    return (react_1.default.createElement("div", { ref: canvasDivElementRef },
        react_1.default.createElement("canvas", { style: {
                width: rotatedWidth,
                height: rotatedHeight,
                backgroundColor: 'transparent',
            }, ref: canvasElementRef })));
};
exports.AcPdfEditorCanvas.displayName = 'AcPdfEditorCanvas';
//# sourceMappingURL=AcPdfEditorCanvas.js.map